module.exports = __webpack_public_path__ + "9a85ef2f2f99e9f54b72fa713c7510b3.jpeg";